import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks/useTypedQuery";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DBBCreateContractPayload } from "components/DBB/components/DBBCreateContractModal/utils";
import type { Car } from "models";

export const useDBBCreateContractMutation = () =>
  useTypedMutation<DBBCreateContractPayload, Car>({
    mutationFn: async payload => (await ApiInstance.post("/dbb/contracts/create", payload, ENV.appointmentBaseURL)).data,
    onSuccess: () => typedQueryClient.invalidateQueries(CarDetailsQueryKeys.details)
  });
